import { Skeleton } from '@mantine/core'
import { BrowserContext } from 'context'
import { useContext } from 'react'

export const SkeletonNotification = () => {
  const { isMobile } = useContext(BrowserContext)

  const avatarSize = isMobile ? 48 : 64
  return (
    <div className="flex gap-20 py-6 px-12 bg-white rounded-16 border-solid border border-1 border-secondary">
      <Skeleton width={avatarSize} height={avatarSize} radius="sm" />

      <div className="flex-1 flex flex-column gap-8">
        <Skeleton width="80%" height={10} radius="xl" />
        <Skeleton width="40%" height={10} radius="xl" />
        <Skeleton width="60%" height={10} radius="xl" />
      </div>
    </div>
  )
}
